'use strict';

var Utils = require('../utils/utils');

// Constructor
var Modal = function() {

  var self = this;
  var $html = $('html');
  var $body = $('body');
  var scrollbarWidth = new Utils().scrollbarWidth();

  self.config = {
    'button'            :  $('[data-show-modal]'),
    'modalWindow'       :  '.modal__window',
    'modalCloseButton'  :  '.modal__close',
    'modalOverlay'      :  '.modal__overlay'
  }

  var $button = self.config.button;
  var modalWindow = self.config.modalWindow;
  var modalCloseButton = self.config.modalCloseButton;
  var modalOverlay = self.config.modalOverlay;

  self.openConfig = function($button, modalWindow, modalCloseButton, modalOverlay) {

    $button.each(function() {

      var $this = $(this);
      var $modal = $('#' + $this.data('show-modal'));
      var $modalWindow = $modal.find(modalWindow);
      var $modalCloseButton = $modal.find(modalCloseButton);
      var $modalOverlay = $modal.find(modalOverlay);

      self.modalDomLocation($modal);
      self.openModal($this, $modal, $modalWindow, $modalOverlay);
      self.closeModal($modalCloseButton, $modal, $modalWindow, $modalOverlay);
      self.closeModal($modalOverlay, $modal, $modalWindow, $modalOverlay);
    });
  }

  self.modalDomLocation = function($modal) {
    $modal.detach().appendTo($body);
  }

  self.openModal = function($button, $modal, $modalWindow, $modalOverlay) {

    $button.on('click', function(e) {
      e.preventDefault();

      self.showModal($modal, $modalWindow, $modalOverlay);
    });
  }

  self.closeModal = function($button, $modal, $modalWindow, $modalOverlay) {

    $button.on('click', function(e) {
      e.preventDefault();

      self.hideModal($modal, $modalWindow, $modalOverlay);
    });
  }

  self.showModal = function($modal, $modalWindow, $modalOverlay) {

    $modal.css('display', 'block');

    $modalOverlay.velocity(
      {
        opacity: 1
      },
      {
        duration: '300ms',
        complete: function() {

          $modal.trigger('modal-is-open');
          $html.addClass('modal-is-open');
          $body.addClass('no-scroll');
          $body.css('padding-right', scrollbarWidth);

          $modalWindow.velocity(
            {
              opacity: 1,
              translateY: [0, '-30%']
            },
            {
              easing: [400, 45],
              complete: function() {
                $modalWindow.addClass('is-active');
              }
            }
          )
        }
      }
    );
  }

  self.hideModal = function($modal, $modalWindow, $modalOverlay) {

    $modalWindow
      .removeClass('is-active')
      .velocity(
      {
        opacity: 0,
        translateY: ['-30%', 0]
      },
      {
        duration: '200ms',
        complete: function() {

          $modalOverlay.velocity(
            {
              opacity: 0
            },
            {
              duration: '150ms',
              complete: function() {
                $modal.css('display', 'none');
                $modal.trigger('modal-is-closed');
                $html.removeClass('modal-is-open');
                $body.removeClass('no-scroll');
                $body.css('padding-right', '0');
              }
            }
          );
        }
      }
    );
  }

  self.init = function() {

    self.openConfig($button, modalWindow, modalCloseButton, modalOverlay);
  }
};

module.exports = Modal;
